// 我的物资dlg组件

const myGoodDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    goodId: '',

    goodName: '',

    goodType: '',

    goodInfo: {},
  },

  getters: {
    dlgShow: state => state.dlgShow,

    goodId: state => state.goodId,

    goodName: state => state.goodName,

    goodType: state => state.goodType,

    goodInfo: state => state.goodInfo
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_GOODID: (state, val) => {
      state.goodId = val
    },

    SET_GOODNAME: (state, val) => {
      state.goodName = val
    },

    SET_GOODTYPE: (state, val) => {
      state.goodType = val
    },

    SET_GOODINFO: (state, val) => {
      state.goodInfo = val
    },
  },

  actions: {

  }
}

export default myGoodDlg
